import bannerRepository from "@api/banner/banner.repository";
import BannerColumn from "@component/banner/BannerColumn";
import BannerContent from "@component/banner/BannerContent";
import BannerDeleteModal from "@component/banner/BannerDeleteModal";
import BannerModal from "@component/banner/BannerModal";
import Container from "@component/common/Container";
import useAuth from "@hook/useAuth";
import { Modal } from "@mui/material";
import {
  bannerDeleteModal,
  bannerRegisterModal,
  bannerUpdateModal,
  bannerOneData,
} from "@store/atom/banner";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

export default function Banner() {
  const { checkAccessToken } = useAuth();

  useEffect(() => {
    checkAccessToken();
  }, []);

  const [banner, setBanner] = useRecoilState(bannerOneData);
  const [registerModal, setRegisterModal] = useRecoilState(bannerRegisterModal);
  const onRegisterCancel = () => {
    setRegisterModal(false);
    setBanner(null);
  };
  const onRegisterSaved = async (order: number, title: string, file: any) => {
    try {
      if (title.length === 0 || order <= 0) {
        return;
      }

      // 1. 배너 생성 (order와 title만으로)
      const banner = await bannerRepository.createOneByOrderAndTitle(order, title);

      // 2. Presigned URL 받기
      const presignedData = await bannerRepository.getPresignedUrl(banner.id);

      // 3. Presigned URL을 사용하여 S3에 직접 파일 업로드
      await fetch(presignedData.url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
        },
      }).then((res) => {
        console.log("res", res);
      }).catch((err) => {
        console.log("err", err);
      });

      // 4. 이미지 정보 업데이트
      await bannerRepository.updateBannerImage(banner.id, presignedData.key);

      setRegisterModal(false);
      setBanner(null);
    } catch (error) {
      console.error('배너 등록 실패:', error);
      // 에러 처리 로직 추가 (예: 에러 메시지 표시)
    }
  };

  const [updateModal, setUpdateModal] = useRecoilState(bannerUpdateModal);
  const onUpdateCancel = () => {
    setUpdateModal(false);
    setBanner(null);
  };
  const onUpdateSaved = async (order: number, title: string) => {
    if (banner && title.length > 0 && order > 0) {
      await bannerRepository.updateOrderAndBanner({
        id: banner.id,
        order,
        title,
      });
    }

    setUpdateModal(false);
    setBanner(null);
  };

  const [bannerDelete, setBannerDelete] = useRecoilState(bannerDeleteModal);
  const onDeleteModalClose = () => {
    setBannerDelete(false);
    setBanner(null);
  };
  const onDeleteBanner = async () => {
    if (banner) {
      await bannerRepository.deleteBannerById(banner.id);
    }

    setBannerDelete(false);
    setBanner(null);
  };

  return (
    <>
      <Container
        title="배너 관리"
        children={<BannerContent />}
        column={<BannerColumn />}
      />
      <Modal open={registerModal} onClose={onRegisterCancel}>
        <BannerModal
          title="배너 등록"
          data={banner}
          onCanceled={onRegisterCancel}
          onSaved={onRegisterSaved}
        />
      </Modal>
      <Modal open={updateModal} onClose={onUpdateCancel}>
        <BannerModal
          title="배너 수정"
          data={banner}
          onCanceled={onUpdateCancel}
          onSaved={onUpdateSaved}
        />
      </Modal>
      <Modal open={bannerDelete} onClose={onDeleteModalClose}>
        <BannerDeleteModal
          onClosed={onDeleteModalClose}
          onDeleted={onDeleteBanner}
        />
      </Modal>
    </>
  );
}
